let forms = {
	claimType: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'claim_category',
				filterable: true,
				clearable: true,
				options: [{ val: 'REPORT', label: 'Report' }],
				validation: 'required',
				label: 'Claim Category',
			},
			{
				type: 'select',
				class: 'col-12',
				model: 'claim_type',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'Claim Type',
			},
		],
	},
	submitReview: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'rate',
				max: 5,
				label: 'Rating',
				model: 'rating',
				colors: {
					active: '#ffdd00',
					inactive: '#999999',
					shadow: '#ffff00',
					hover: '#dddd00',
				},
				class: 'col-12',
				placeholder: 'Your Rating',
			},
			{
				type: 'textarea',
				label: 'Review',
				model: 'review',
				validation: 'required|min:10|max:1000',
				class: 'col-12',
				placeholder: 'Your Review',
			},
		],
	},
	policy_cancelation_remarks: {
		icon: 'fa fa-user',
		title: 'Cancel Policy',
		subtitle: 'Policy Cancellation Remarks',
		forms: [
			{
				type: 'textarea',
				class: 'col-12',
				rows: 3,
				model: 'remarks',
				validation: 'required|min:10|max:1000',
				label: 'Cancelation Remarks',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
